<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="toc">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample"><span class="epub-i">Title Page</span></span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample"><span class="epub-i">Copyright Notice</span></span></p>
<p class="toc-bot"><a href="#/xhtml/dedication#ded"><span class="epub-i">Dedication</span></a></p>
<p class="toc-bot1"><a href="#/xhtml/prologue#prologue"><span class="epub-i">Prologue</span></a></p>
<p class="toc"><span href="#/xhtml/chapter1#ch1" title="Link target outside of Sample">The First Test: Love in the Time of <span class="epub-i">Khap</span></span></p>
<p class="toc"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">The Second Test: Diamonds and Rust</span></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">The Third Test: Locked Dreams</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">The Fourth Test: The Blindness of Fame</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">The Fifth Test: The Atlas of Revolution</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">The Sixth Test: 150 grams of Sacrifice</span></p>
<p class="toc-bot1"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">The Seventh Test: Acid Rain</span></p>
<p class="toc-bot"><span href="#/xhtml/epilogue#epilogue" title="Link target outside of Sample"><span class="epub-i">Epilogue</span></span></p>
<p class="toc"><span href="#/xhtml/ack#ack" title="Link target outside of Sample"><span class="epub-i">Acknowledgements</span></span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample"><span class="epub-i">Also by Vikas Swarup</span></span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample"><span class="epub-i">Copyright</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3a88acde